import React, { PureComponent } from 'react';
import { func, bool, string, arrayOf, number } from 'prop-types';
import Radium from 'radium';
import numeral from 'numeral';
import { UTLabel } from '@widergy/energy-ui';

import UTDownload from 'app/components/UTDownloadBill';
import UTTable from 'app/components/UTTable';
import UTMobileTable from 'app/components/UTMobileTable';
import UTCheckbox from 'app/components/UTCheckbox';
import { message } from 'utils/stringUtils';
import { accountUnpaidType, debtsType } from 'types/paymentTypes';
import { DefaultViewport, MobileViewport } from 'constants/deviceSizes';
import { PAYMENTS } from 'constants/common';
import { billsActiveRowSize as activeRowSize, inactiveRowSize } from 'constants/sizes';

import tableStyles from '../../../Claims/styles';

import stylesJS from './styles';
import styles from './styles.module.scss';
import DetailHeader from './components/DetailHeader';
import { retrieveColumns, retrieveMobileColumns } from './constants';

const amountRenderer = ({ cellData }) =>
  cellData !== null &&
  cellData !== undefined && (
    <UTLabel small semibold>
      {numeral(cellData).format('$0,0.00')}
    </UTLabel>
  );

class AccountPaymentDetails extends PureComponent {
  mobileDownloadRenderer = bill => (
    <div style={stylesJS.oddRow}>
      <UTLabel small bold>{`${message('AccountStatus:downloadBill')}:`}</UTLabel>
      <UTDownload
        loading={this.props.paymentDocumentLoading}
        loadingMessage={message('Payments:paymentDocumentLoading')}
        title={message('Payments:downloadPaymentDocument')}
        downloadUrl={this.props.paymentDocumentUrl}
        onClickDownload={() => this.props.onDownloadPaymentDocument(bill)}
        labelButton={message('Payments:download')}
        disabled={!bill.downloadable}
      />
    </div>
  );

  checkboxRenderer = ({ rowData }) =>
    !rowData.multipleDownload &&
    rowData.payable && (
      <UTCheckbox
        onChange={() => this.props.handleOnChange(rowData)}
        value={this.props.list.findIndex(item => item.external_id === rowData.external_id) !== -1}
      />
    );

  downloadRenderer = ({ rowData }) => (
    <div style={stylesJS.downloadButtonContainer}>
      <UTDownload
        loading={this.props.paymentDocumentLoading || this.props.multiplePaymentDocumentsLoading}
        loadingMessage={
          rowData.multipleDownload
            ? message('Payments:multiplePaymentDocumentsLoading')
            : message('Payments:paymentDocumentLoading')
        }
        title={
          rowData.multipleDownload
            ? message('Payments:downloadAll')
            : message('Payments:downloadPaymentDocument')
        }
        downloadUrl={
          rowData.multipleDownload
            ? this.props.multiplePaymentDocumentsUrl &&
              this.props.multiplePaymentDocumentsUrl.paymentDocuments
            : this.props.paymentDocumentUrl
        }
        onClickDownload={() =>
          rowData.multipleDownload
            ? this.props.onDownloadAllPaymentDocuments()
            : this.props.onDownloadPaymentDocument(rowData)
        }
        labelButton={
          rowData.multipleDownload ? message('Payments:downloadAll') : message('Payments:download')
        }
        className={styles.downloadButton}
        disabled={!rowData.downloadable}
      />
    </div>
  );

  mobileMultipleDownloadRender = row =>
    row.downloadable && (
      <div className={styles.downloadAllContainer}>{this.downloadRenderer({ rowData: row })}</div>
    );

  mobileColumns = bill =>
    retrieveMobileColumns(bill, this.props.list, this.handleOnChange, this.mobileDownloadRenderer);

  handlePayment = () => this.props.handleAccountPayment(this.props.account);

  render() {
    return (
      <div style={stylesJS.container}>
        <DetailHeader
          account={this.props.account}
          handleCheckAll={this.props.handleCheckAll}
          checkAll={this.props.checkAll}
          handleOnPress={this.props.handleOnPress}
          isOpen={this.props.isOpen}
          isPublic={this.props.isPublic}
          accountTotalAmount={this.props.accountTotalAmount}
          onOpenPaymentDocumentModal={this.props.onOpenPaymentDocumentModal}
        />
        {this.props.isOpen && (
          <div>
            <DefaultViewport>
              <div style={this.props.isOpen ? stylesJS.tableIsOpen : stylesJS.tableIsClosed}>
                <UTTable
                  gridStyle={stylesJS.gridStyle}
                  columns={retrieveColumns(this.checkboxRenderer, amountRenderer, this.downloadRenderer)}
                  rows={this.props.rows}
                  activeRowStyle={tableStyles.activeRowStyle}
                  rowHeight={(index, activeRowIndex) =>
                    index === activeRowIndex ? activeRowSize : inactiveRowSize
                  }
                  height={stylesJS.tableIsOpen.height}
                  headerHeight={46}
                  backgroundColor={stylesJS.tableIsOpen.backgroundColor}
                  id={PAYMENTS}
                  onRowsRendered={this.props.onRowsRendered}
                  scrolleable
                  withoutOddStyle
                  unbordered
                  centered
                />
              </div>
            </DefaultViewport>
            <MobileViewport>
              <UTMobileTable
                onChange={this.props.handleOnChange}
                tables={this.props.rows}
                rowRenderer={this.mobileColumns}
              />
              {this.props.rows.filter(el => el.multipleDownload).map(this.mobileMultipleDownloadRender)}
            </MobileViewport>
          </div>
        )}
      </div>
    );
  }
}

AccountPaymentDetails.propTypes = {
  account: accountUnpaidType,
  accountTotalAmount: number,
  handleOnChange: func,
  onRowsRendered: func,
  handleOnPress: func,
  rows: arrayOf(debtsType),
  isOpen: bool,
  list: arrayOf(debtsType),
  onDownloadAllPaymentDocuments: func,
  onDownloadPaymentDocument: func,
  paymentDocumentLoading: bool,
  paymentDocumentUrl: string,
  multiplePaymentDocumentsLoading: bool,
  multiplePaymentDocumentsUrl: string,
  handleCheckAll: func,
  checkAll: bool,
  handleAccountPayment: func,
  onOpenPaymentDocumentModal: func,
  isPublic: bool
};

export default Radium(AccountPaymentDetails);
